/* istanbul ignore file */
import React from 'react';
import { BaseFieldLayoutProps, BaseFieldLayoutType } from '../../field';

const SimpleFieldLayout: BaseFieldLayoutType = ({ label, value }: BaseFieldLayoutProps) => {
  return (
    <>
      {!!label && `${label}: `}
      {value}
    </>
  );
};

export default SimpleFieldLayout;
